import React, { useEffect } from 'react';

import { Input } from 'twyne-new.ui'

import PropertyItem from './Property';
import { TYPE_VALUE } from './types';

export default class ValuePropertyItem extends PropertyItem {
  accept = []
  title = "value-property"
  model = TYPE_VALUE

  PropertyValue = ({ value, setValue }) => {

    useEffect(() => {
      setValue('{value}')
    }, [])

    return <div className='pr-4'>
      <Input value={value} disabled />
    </div>
  }
}